"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubtitleContainer = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _view = require("../../types/view");
var _headingType = require("../../types/headingType");
var _view2 = require("../../selectors/view/view");
var _SubtitleLayout = require("../../components/SubtitleLayout");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SubtitleContainer = _ref => {
  let {
    useSelector
  } = _ref;
  const {
    active,
    data
  } = useSelector(_view2.selectView);
  switch (active) {
    case _view.EActiveView.AuthenticationRegistration:
    case _view.EActiveView.PhoneAuth:
      switch (data?.headingType) {
        case _headingType.EHeadingType.Notifications:
          return /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, null, "\u0421\u043E\u043E\u0431\u0449\u0438\u043C \u043E\u0431 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0446\u0435\u043D\u044B \u0438\xA0\u043D\u043E\u0432\u044B\u0445\xA0\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u043F\u043E\u0438\u0441\u043A\u0443"));
        default:
          return null;
      }
    default:
      return null;
  }
};
exports.SubtitleContainer = SubtitleContainer;